import type React from "react";

import { faBookOpen, faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import {
  faBookOpen as faBookOpenSolid,
  faQuestionCircle as faQuestionCircleSolid,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";
import styled, { useTheme } from "styled-components";

export type SelectedScreen = {
  index: number;
  screen: "text_lesson" | "quiz";
};

interface Props {
  totalQuestions: number;
  selectedScreen: SelectedScreen;
  setSelectedScreen: React.Dispatch<React.SetStateAction<SelectedScreen>>;
}

export const ScreenSelector: React.FC<Props> = ({ totalQuestions, selectedScreen, setSelectedScreen }) => {
  const theme = useTheme();

  return (
    <QuestionsContainer>
      <IconButton onClick={() => setSelectedScreen({ screen: "text_lesson", index: 0 })}>
        <QuestionButtonContent>
          <FontAwesomeIcon
            icon={selectedScreen.screen === "text_lesson" ? faBookOpenSolid : faBookOpen}
            color={theme.colors.redesign.t100}
          />
        </QuestionButtonContent>
      </IconButton>

      {Array.from({ length: totalQuestions }).map((_, index) => {
        const key = `part-question-${index}`;
        const selected = selectedScreen.screen === "quiz" && selectedScreen.index === index;
        return (
          <IconButton key={key} onClick={() => setSelectedScreen({ screen: "quiz", index })}>
            <QuestionButtonContent>
              <FontAwesomeIcon
                icon={selected ? faQuestionCircleSolid : faQuestionCircle}
                color={theme.colors.redesign.o100}
              />
              <QuestionNumber>{index + 1}</QuestionNumber>
            </QuestionButtonContent>
          </IconButton>
        );
      })}
    </QuestionsContainer>
  );
};

const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  order: 1;

  ${({ theme }) => theme.aboveBreakpoint} {
    flex-direction: column;
    order: 0;
  }
`;

const QuestionButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;

  & > svg {
    font-size: 24px;
  }
`;

const QuestionNumber = styled.div`
  font-size: 20px;
  font-weight: 700;
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.redesign.o100};
`;
